import React, { forwardRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: SelectOption[];
  placeholder?: string;
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  error,
  options,
  placeholder,
  className = '',
  id,
  ...props
}, ref) => {
  const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-333">
        {label && <label htmlFor={selectId} className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-334">
            {label}
          </label>}
        <div className="relative" data-id="element-335">
          <select ref={ref} id={selectId} className={`
              w-full px-4 py-2.5 pr-10 rounded-xl border bg-white appearance-none
              text-slate-900 transition-colors duration-200
              focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent
              disabled:bg-slate-50 disabled:text-slate-500 disabled:cursor-not-allowed
              ${error ? 'border-red-500 focus:ring-red-500' : 'border-slate-200 hover:border-slate-300'}
              ${className}
            `} {...props} data-id="element-336">
            {placeholder && <option value="" disabled data-id="element-337">
                {placeholder}
              </option>}
            {options.map(option => <option key={option.value} value={option.value} data-id="element-338">
                {option.label}
              </option>)}
          </select>
          <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" data-id="element-339" />
        </div>
        {error && <p className="mt-1.5 text-sm text-red-500" data-id="element-340">{error}</p>}
      </div>;
});
Select.displayName = 'Select';